import * as React from "react";

function IconClose(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 18" fill="none" {...props}>
      <rect x="3.41418" y="2" width="17.4333" height="2" rx="1" fill="currentColor" transform="rotate(45 3.41418 2)" />
      <rect
        x="2.1814"
        y="14.3273"
        width="17.4333"
        height="2"
        rx="1"
        fill="currentColor"
        transform="rotate(-45 2.1814 14.3273)"
      />
    </svg>
  );
}

export default IconClose;
